import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import CrudFinishedGoods from "../../organisms/FinishedGoods/CrudFinishedGoods";
import { useCompany } from "../../contexts/CompanyContext";
import { Box, Typography } from "@mui/material";

export default function FinishedGoodScreen() {
  const { selectedCompany } = useCompany();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [selectedCompany]);

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Please select a company first</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <CrudFinishedGoods key={key} props={{ companyId: selectedCompany.id }} />
    </DashboardLayout>
  );
}
